import Image from "next/image";
import Link from "next/link";
import { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function UnderConstruction({ spaceSlug, error }) {
  const router = useRouter();
  const isUnavailableUrl =
    error?.message === "This URL is not available for use";

  const handleClaimDifferentClick = () => {
    if (typeof window !== "undefined" && window.umami) {
      window.umami.track("space_claim_referral", {
        source: "unavailable_page",
        slug: spaceSlug,
      });
    }
    router.push("/onboarding");
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 text-center bg-gradient-to-b from-indigo-600 to-purple-700">
      <Image
        src="/logos/beta/white.svg"
        alt="Logo"
        width={180}
        height={60}
        className="mb-8"
      />
      <h1 className="text-4xl font-bold mb-4 text-white">Space Unavailable</h1>

      <div className="bg-white/10 rounded-lg px-8 py-4 mb-8 backdrop-blur-sm">
        <p className="text-3xl font-mono text-white">
          qensa.me/<span className="text-yellow-400">{spaceSlug}</span>
        </p>
      </div>

      <p className="text-xl text-white/80 mb-6 max-w-lg">
        {error?.message || "This space is currently under construction."}
      </p>

      <div className="space-y-6">
        {isUnavailableUrl ? (
          <>
            <div className="flex flex-col items-center space-y-2">
              <h3 className="text-xl font-semibold text-white">
                Looking for a space?
              </h3>
              <p className="text-white/80">
                Create your own personalized space with a different name
              </p>
            </div>

            <button
              onClick={handleClaimDifferentClick}
              className="inline-block px-8 py-4 bg-white text-black rounded-lg font-semibold hover:bg-white/90 transition-colors"
            >
              Claim a Different Space
            </button>
          </>
        ) : (
          <>
            <div className="flex flex-col items-center space-y-2">
              <h3 className="text-xl font-semibold text-white">
                Is this your space?
              </h3>
              <p className="text-white/80">
                Sign in to access or manage this space
              </p>
            </div>

            <Link
              href="/signin"
              className="inline-block px-8 py-4 bg-white text-black rounded-lg font-semibold hover:bg-white/90 transition-colors"
            >
              Sign in to Access
            </Link>

            <p className="text-white/60 text-sm">
              Don't have an account?{" "}
              <Link
                href="/onboarding"
                className="text-white underline hover:text-white/90"
              >
                Sign up
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
